import { useCallback } from 'react';
import { FeatureGate, useFeatureGate } from '@featureFlags/index';
import { canPreviewHtml } from './canPreviewHtml';

export const useCanPreviewHtml = (): ((name: string, fileSize: number, contentType?: string) => boolean) => {
  const enabled = useFeatureGate(FeatureGate.OS_APP_HTML_VIEW);
  return useCallback(
    (name, fileSize, contentType) => enabled && canPreviewHtml(name, fileSize, contentType),
    [enabled],
  );
};
